import * as React from "react";
import { useRouter } from "next/router";
import { useOrchestrators } from "@nju/data-access-portal-orchestrator";
import { portalRoutes } from "@nju/routes";
import { GeneralErrorNotification, Panel, Separator } from "@nju/ui";
import { AppointmentForm } from "./AppointmentForm";

export function DashboardChangeAppointmentDate() {
  const router = useRouter();
  const ftth = useOrchestrators("ftth", { isOptional: true });

  const onSubmit = React.useCallback(() => {
    router.push(portalRoutes.mojeKonto.index.get({ mode: "ftth" }));
  }, [router]);

  if (!ftth) {
    return <GeneralErrorNotification callback={onSubmit} />;
  }

  return (
    <Panel>
      <Separator size="xs" tone="invisible" />
      <AppointmentForm
        ftthOrchestrator={ftth}
        mode="CHANGE_FULFILLMENT"
        onSubmit={onSubmit}
      />
    </Panel>
  );
}
